import React from "react";
import CartQuantityPicker from "../CartQuantityPicker/CartQuantityPicker";
import "../CheckoutPanel/CheckoutPanel.css";

const SummaryList = ({ items, packages, currency }) => (
  <ul className="summary-list">
    {(items || []).map((cartItem) => {
      const pkg = packages.find((p) => p.id === cartItem.id) || cartItem;
      const rawCode = pkg.country_id || pkg.region_id;
      const flagCode = rawCode ? String(rawCode).toLowerCase() : "";
      const isRegion = !!pkg.region_id;
      const folder = pkg.country_id ? "flags" : "regions";
      const qty = cartItem.quantity || 1;

      return (
        <li className="summary-item" key={cartItem.id}>
          <div className="summary-item__product">
            <div className="summary-flag-wrapper">
              <img
                className={`summary-flag ${isRegion ? "summary-flag--region" : ""}`}
                src={`/icons/${folder}/${flagCode}.png`}
                alt={`${flagCode} flag`}
              />
            </div>
            <div className="summary-item__info">
              <div className="summary-item__name">{pkg.name}</div>
            </div>
          </div>
          <CartQuantityPicker item={cartItem} />
          <div className="summary-item__price">{currency((pkg.price || 0) * qty, pkg.currency)}</div>
        </li>
      );
    })}
  </ul>
);

export default SummaryList;
